module.exports = __webpack_public_path__ + "staticcomp/img/content_1.07c4b17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/1/content_1.jpg
// module id = hGWw
// module chunks = 39